import { ITimeBooking } from "../interfaces/ITimeBooking";
import { thanos26Delete, thanos26Get, thanos26Json, thanos26Put } from "./thanos26Client";

/** Running (clocked in) timebooking of the signed in user, stored in thanos26. null = not clocked in */
async function getAktiveZeitbuchung(): Promise<ITimeBooking | null> {
    return thanos26Json(await thanos26Get("timesafe/zeitbuchung"));
}

async function saveAktiveZeitbuchung(zeitbuchung: ITimeBooking): Promise<void> {
    await thanos26Json(await thanos26Put("timesafe/zeitbuchung", {}, zeitbuchung));
}

/** Remove the running timebooking after it was booked in TimeSafe */
async function deleteAktiveZeitbuchung(): Promise<void> {
    await thanos26Json(await thanos26Delete("timesafe/zeitbuchung"));
}

export default { getAktiveZeitbuchung, saveAktiveZeitbuchung, deleteAktiveZeitbuchung };
